import { Link } from "react-router-dom";

/**
 * @param {{ blurb?: string; secondaryTo?: string; secondaryLabel?: string }} props
 */
export default function SiteFooter({ blurb, secondaryTo = "/about", secondaryLabel = "About" }) {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="container">
        <p>
          © {year} FreshClayPotCurd.           {blurb ? <> {blurb}</> : null}
          <Link to="/legal">Terms & Conditions</Link>
        </p>
      </div>
    </footer>
  );
}
